export default __webpack_public_path__ + "media/src/assets/fonts/Bitter-Italic-050aa1c83047c07c7423eef8e00964ee.ttf";